import React from "react";
import "./EABadge.scss";

interface IProps {
  value: string | number;
  children: React.ReactNode;
}

const EABadge: React.FC<IProps> = ({ value, children }) => {
  if (value) {
    return (
      <div className="badge-container">
        {children}
        <div className="badge">{value}</div>
      </div>
    );
  } else {
    return <>{children}</>;
  }
};

export default EABadge;
